class WishlistObjectQf {
  constructor() {
    this.LOCAL_STORAGE_WISHLIST_KEY = "qf-shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active-wishlist";
    this.GRID_LOADED_CLASS = "loaded";

    this.needsUpdate = true; 

    this.selectors = {
      button: "[button-wishlist]",
      clearWishlist: ".clear-wishlist",
      grid: "[grid-wishlist]",
      gridContainer: ".wishlist-grid-container",
      //sideCartGrid: "[side-cart-grid-wishlist]",
      productCard: ".product-card"
    };

    this.init()
  }

  init() {
    this.wishlistCount();
    this.initButtons();
    this.initGrid().then(() => {
      this.buttonCheck();
    })
    this.addEventListeners()
  }

  buttonCheck() {
    let vm = this;
    let buttons = document.querySelectorAll(this.selectors.button);
    buttons.forEach((button) => {
      const productHandle = button.dataset.productHandle || false;
      if (vm.wishlistContains(productHandle)) {
        button.classList.add(vm.BUTTON_ACTIVE_CLASS);
      }
    })
  }

  initButtons = () => {
    let vm = this;
    document.body.addEventListener('click', function (e) {

      // Checks to see if the target that has been clicked contains wishlist data attribute
      const button = e.target.closest(vm.selectors.button);
      if (button) {
        e.preventDefault();
        // Creates object from selected attributes
        let attributes = {};
        document.querySelectorAll("input[type='radio']").forEach(radioInput => {
          if (radioInput.checked) {
            attributes[radioInput.name] = radioInput.value;
          }
        });

        const product = {
          handle: button.dataset.productHandle || false,
          attributes,
        };
        const productObject = Object.create(product);

        // checks to see if the data attribute for product handle exists and outputs an error if not
        if (!productObject) {
          return console.error(
            "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
          );
        } else {
          vm.updateWishlist(product, e);
        }

        // Grabs all wishlist buttons and adds active state
        let allButtonsForHandle = document.querySelectorAll(
          `${vm.selectors.button}[data-product-handle="${button.dataset.productHandle}"]`
        );
        if (allButtonsForHandle) {
          allButtonsForHandle.forEach((buttonAddClass) => {
            buttonAddClass.classList.toggle(vm.BUTTON_ACTIVE_CLASS);
          });
        }
        vm.wishlistCount();
      }

      // Checks to see if the target that has been clicked contains clear wishlist class
      const clearButton = e.target.closest(vm.selectors.clearWishlist);
      if (clearButton) {
        vm.resetWishlist();
        vm.initGrid()
      }
    });

    document.dispatchEvent(new CustomEvent("shopify-wishlist:init-buttons", {
      detail: { wishlist: vm.getWishlist() },
    }));
  };

  addEventListeners() {
    window.addEventListener('desktop-cart-recommendations-rendered', ()=>{
      //TODO: Find better fix to update buttons afer recommended for you is initialised
      setTimeout(()=>{
        this.buttonCheck();
      },500)
    })
  } 

  wishlistCount() {
    if(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) && JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)).length > 0) {
        document.getElementById('wishlistCount').classList.remove('is-hidden');
        const wishlistNumber = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) ? JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY)).length : 0;
        document.getElementById('wishlistCount').innerHTML = wishlistNumber;

        const wishlistPageCount = document.getElementById('wishlistPageCount');
        if (wishlistPageCount) {
          wishlistPageCount.classList.remove('is-hidden');
          wishlistPageCount.innerHTML = wishlistNumber + ' items';
        }
        
        const clearWishlist = document.querySelector('.clear-wishlist');
        if (clearWishlist) {
          clearWishlist.classList.remove('is-hidden');
        }
        
    } else {
      document.getElementById('wishlistCount').classList.add('is-hidden');

      const wishlistPageCount = document.getElementById('wishlistPageCount');
      if (wishlistPageCount) {
        wishlistPageCount.classList.add('is-hidden');
      }

      const clearWishlist = document.querySelector('.clear-wishlist');
        if (clearWishlist) {
          clearWishlist.classList.add('is-hidden');
        }
    }
  }

  wishlistContains = (handle) => {
    const wishlist = this.getWishlist();
    const wishlistString = JSON.stringify(wishlist)

    return wishlistString.includes(handle);
  };

  getWishlist = () => {
    const wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return JSON.parse(wishlist);
    return [];
  };

  updateWishlist = (wishlistItem, e=null) => {
    const wishlist = this.getWishlist();
    const indexInWishlist = wishlist.findIndex(item => item.handle == wishlistItem.handle);
    if (indexInWishlist === -1) wishlist.push(wishlistItem);
    else wishlist.splice(indexInWishlist, 1);

    return this.setWishlist(wishlist, e);
  };

  setWishlist = (array, e) => {
    const wishlist = JSON.stringify(array);
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      document.dispatchEvent(new CustomEvent("shopify-wishlist:updated", {
        detail: { wishlist: array },
      }));
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
      window.log("wishlist had no length");
      this.initGrid();

    }
    //this.updateSideCartWishlist(e)
  }

  resetWishlist = () => {
    let vm = this;
    let allWishlistButtons = document.querySelectorAll(vm.selectors.button);
    allWishlistButtons.forEach((button) => {
      button.classList.remove(vm.BUTTON_ACTIVE_CLASS);
    });

    const wishlistCount = document.getElementById('wishlistCount');
    if (wishlistCount) {
      wishlistCount.classList.add('is-hidden');
    }

    const wishlistPageCount = document.getElementById('wishlistPageCount');
    if (wishlistPageCount) {
      wishlistPageCount.classList.add('is-hidden');
    }

    return vm.setWishlist([]);
  };

  // Class to generate the grid in the withlist page
  async initGrid () {
    let vm = this;
      // This checks if the wishlist grid data attribute exits
      const grid = document.querySelector(vm.selectors.grid) || false;
      const gridContainer = document.querySelector(vm.selectors.gridContainer)

      if(!grid || !gridContainer){

        return 
      }

      if (grid) {
        grid.innerHTML = "";
  
      // This grabs the wishlist list from the local storage
        const wishlist = this.getWishlist();
        const fallback = gridContainer.querySelector('.empty-wishlist');

        if(wishlist.length == 0) {
          grid.classList.add(vm.GRID_LOADED_CLASS);

          if(fallback){
           fallback.classList.add('show')
          }
           return
        }
        else{

          if(fallback){
            fallback.classList.remove('show')
           }
        }
  
        grid.classList.remove(vm.GRID_LOADED_CLASS);
  
        let counter = 0; 
  
        for (let i = 0; i < wishlist.length; i++) {
          const wishlistItem = wishlist[i];
  
          let productTileTemplateUrl = window.Shopify.routes.root + `products/${wishlistItem.handle}?view=card&section_id=v2-product-card`;
  
          fetch(productTileTemplateUrl)
            .then(response => {
              if (response.ok) {
                return response.text();
              } else {
                throw new Error("Error: " + response.status);
              }
            })
            .then(data => {
              const htmlDocument = new DOMParser().parseFromString(data, "text/html");
              const productCard = htmlDocument.documentElement.querySelector(vm.selectors.productCard);

              const wishlistButton = productCard.querySelector('.button-wishlist');
              if (wishlistButton) wishlistButton.classList.add(this.BUTTON_ACTIVE_CLASS);

              document.querySelector(vm.selectors.grid).insertAdjacentHTML('beforeend', productCard.outerHTML);

              // Handle fade in
              counter++;
              if (counter === 10) {
                grid.classList.add(vm.GRID_LOADED_CLASS);
              }
              if (counter === wishlist.length) {
                grid.classList.add(vm.GRID_LOADED_CLASS);
                document.dispatchEvent(new CustomEvent("shopify-wishlist:init-product-grid", {
                  detail: { wishlist: wishlist },
                }));
              }
            })
            .catch(error => {
              console.error(error);
            });

        }
      }
  
  };

  // initSideCartGrid() {
  //   let vm = this;

  //   // This checks if the wishlist grid data attribute exits
  //   const grid = document.querySelector(vm.selectors.sideCartGrid) || false;
  //   if (grid) {
  //     grid.innerHTML = "";

  //   // This grabs the wishlist list from the local storage
  //     const wishlist = this.getWishlist();

  //     if(wishlist.length == 0) {
  //       grid.classList.add(vm.GRID_LOADED_CLASS);
  //       grid.innerHTML = '<span class="empty-wishlist"> You have no saved products </span>'
  //       return
  //     }

  //     grid.classList.remove(vm.GRID_LOADED_CLASS);

  //     let counter = 0; 

  //     for (let i = 0; i < wishlist.length; i++) {
  //       const wishlistItem = wishlist[i];

  //       let productTileTemplateUrl = window.Shopify.routes.root + `products/${wishlistItem.handle}?view=card&section_id=v2-product-card`;

  //       fetch(productTileTemplateUrl)
  //         .then(response => {
  //           if (response.ok) {
  //             return response.text();
  //           } else {
  //             throw new Error("Error: " + response.status);
  //           }
  //         })
  //         .then(data => {
  //           const htmlDocument = new DOMParser().parseFromString(data, "text/html");
  //           const productCard = htmlDocument.documentElement.querySelector(vm.selectors.productCard);

  //           const wishlistButton = productCard.querySelector('.button-wishlist');
  //           if (wishlistButton) wishlistButton.classList.add(this.BUTTON_ACTIVE_CLASS);

  //           document.querySelector(vm.selectors.sideCartGrid).insertAdjacentHTML('beforeend', productCard.outerHTML);

  //           // Handle fade in
  //           counter++;
  //           if (counter === 6) {
  //             grid.classList.add(vm.GRID_LOADED_CLASS);
  //           }
  //           if (counter === wishlist.length) {
  //             grid.classList.add(vm.GRID_LOADED_CLASS);
  //             document.dispatchEvent(new CustomEvent("shopify-wishlist:init-product-grid-side-cart", {
  //               detail: { wishlist: wishlist },
  //             }));
  //           }
  //         })
  //         .catch(error => {
  //           console.error(error);
  //         });

  //     }
  //   }
  // };

  // updateSideCartWishlist(e) {

  //   const grid =  e.target.closest('.side-cart-saved-grid.loaded')
  //   if(grid){
  //     const productCard = e.target.closest(".product-card")
  //     if(productCard) productCard.remove()
  //   }else{
  //     this.initSideCartGrid();
  //   }
  // }
}

window.WishlistObjectQf = WishlistObjectQf;